import { render, staticRenderFns } from "./defTableSocketProcess.vue?vue&type=template&id=116f950b&"
import script from "./defTableSocketProcess.vue?vue&type=script&lang=js&"
export * from "./defTableSocketProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports